import { UserAnswers } from './types';

export function setPatientFormValue(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- UserAnswers declares only some of the ~100 fields read below; typing the rest is a types refactor
  userAnswers: UserAnswers | any,

  setDiagnosedConditions: (value: string[]) => void,
  setAssociatedSymptoms: (value: string[]) => void,
  setAuraSymptoms: (value: string[]) => void,
  setTriggers: (value: string[]) => void
) {
  const data = userAnswers?.data?.formQuestionnaire?.data;

  const hasPreviousPainMedication = data?.hasPreviousPainMedication;

  const preventiveMedication = data?.preventiveMedication;
  const preventiveMedicationHeadic = data?.preventiveMedicationHeadic;
  const hasPreviousPreventiveMedication = data?.hasPreviousPreventiveMedication;
  const otherPreventiveMedication = data?.otherPreventiveMedication;
  const otherPreventiveMedicationOtherNo =
    data?.otherPreventiveMedicationOtherNo;
  const hasAdditionalAttackMedication = data?.hasAdditionalAttackMedication;
  const hasOtherPreviousPainMedicationStopSecond =
    data?.hasOtherPreviousPainMedicationStopSecond;
  const hasOtherPreviousPainMedicationStop =
    data?.hasOtherPreviousPainMedicationStop;
  const otherAlergy = data?.otherAlergy;
  const weight = data?.weight;
  const height = data?.height;
  const mrtDate = data?.mrtDate;
  const mrtLocation = data?.mrtLocation;

  const painMedicationName = data?.painMedicationName;
  const painMedicationDose = data?.painMedicationDose;
  const neurologicalFamilyDiagnosis = data?.neurologicalFamilyDiagnosis;
  const neurologicalFamilyRelation = data?.neurologicalFamilyRelation;
  const overusedMedication = data?.overusedMedication;
  const previousMedicationName = data?.previousMedicationName;
  const previousMedicationNameSecond = data?.previousMedicationNameSecond;
  const previousMedicationDose = data?.previousMedicationDose;
  const previousMedicationDoseSecond = data?.previousMedicationDoseSecond;
  const previousMedicationEffectiveness = data?.previousMedicationEffectiveness;
  const previousMedicationEffectivenessSecond =
    data?.previousMedicationEffectivenessSecond;
  const previousMedicationFrequency = data?.previousMedicationFrequency;
  const previousMedicationFrequencySecond =
    data?.previousMedicationFrequencySecond;
  const previousMedicationStartYear = data?.previousMedicationStartYear;
  const previousMedicationStartYearSecond =
    data?.previousMedicationStartYearSecond;
  const previousMedicationStopReasonSecond =
    data?.previousMedicationStopReasonSecond;
  const previousMedicationStopReason = data?.previousMedicationStopReason;
  const previousMedicationStopYear = data?.previousMedicationStopYear;
  const radiologyDate = data?.radiologyDate;
  const radiologyLocation = data?.radiologyLocation;
  const describeAnomaly = data?.describeAnomaly;
  const withdrawalDate = data?.withdrawalDate;
  const otherPreventiveMedicationOtherNoWitch =
    data?.otherPreventiveMedicationOtherNoWitch;
  const otherPreventiveMedicationOtherNoWhatReaktion =
    data?.otherPreventiveMedicationOtherNoWhatReaktion;
  const otherHeadacheType = data?.otherHeadacheType;
  const diagnosedConditionsDateOther = data?.diagnosedConditionsDateOther;
  const previousMedicationOtherReason = data?.previousMedicationOtherReason;
  const previousMedicationSideEffect = data?.previousMedicationSideEffect;
  const previousMedicationOtherReasonTwo =
    data?.previousMedicationOtherReasonTwo;
  const preventiveMedicationDoseHeadic = data?.preventiveMedicationDoseHeadic;
  const preventiveMedicationStartYearHeadic =
    data?.preventiveMedicationStartYearHeadic;
  const preventiveMedicationSideEffectsHeadic =
    data?.preventiveMedicationSideEffectsHeadic;
  const preventiveMedicationSideEffectDetailsHeadic =
    data?.preventiveMedicationSideEffectDetailsHeadic;
  const hasAdditionalPreventiveMedicationHeadic =
    data?.hasAdditionalPreventiveMedicationHeadic;
  const bloodPressureValue = data?.bloodPressureValue;
  const otherPreventiveMedicationOther = data?.otherPreventiveMedicationOther;
  const otherPreventiveMedicationNameOne =
    data?.otherPreventiveMedicationNameOne;
  const otherPreventiveMedicationNameTwo =
    data?.otherPreventiveMedicationNameTwo;
  const otherPreventiveMedicationNameThree =
    data?.otherPreventiveMedicationNameThree;
  const otherPreventiveMedicationNameThreeText =
    data?.otherPreventiveMedicationNameThreeText;
  const otherPreventiveMedicationName = data?.otherPreventiveMedicationName;
  const additionalInfoText = data?.additionalInfoText;

  let ageFirstAttack = data?.ageFirstAttack;
  let headacheDuration = data?.headacheDuration;
  let painLocation = data?.painLocation;
  let painCharacter = data?.painCharacter;
  let painIntensity = data?.painIntensity;
  let preferredActionDuringAttack = data?.preferredActionDuringAttack;
  let dizzinessDuration = data?.dizzinessDuration;
  let headacheFrequency = data?.headacheFrequency;
  let frequencyDuration = data?.frequencyDuration;
  let initialFrequency = data?.initialFrequency;
  let headacheFreeDays = data?.headacheFreeDays;
  let worseningDuration = data?.worseningDuration;
  let neurologicalFamilyDiseases = data?.neurologicalFamilyDiseases;

  const missingDiaryInfo = data?.missingDiaryInfo;
  const diagnosisConditionsData = data?.diagnosisConditionsData;
  const diagnosisConditionsDataSpanningshuvudvark =
    data?.diagnosisConditionsDataSpanningshuvudvark;
  const diagnosedConditionsDateSpanningshuvudvark =
    data?.diagnosedConditionsDateSpanningshuvudvark;
  const diagnosisConditionsDataHorton = data?.diagnosisConditionsDataHorton;
  const diagnosedConditionsDateHorton = data?.diagnosedConditionsDateHorton;
  const diagnosedConditionsDateMigran = data?.diagnosedConditionsDateMigran;
  const bettskenEffect = data?.bettskenEffect;
  const massageEffect = data?.massageEffect;
  const acupunctureEffect = data?.acupunctureEffect;
  const tensEffect = data?.tensEffect;
  const yogaEffect = data?.yogaEffect;
  const naprapatEffect = data?.naprapatEffect;
  const preventiveMedicationNameHeadic = data?.preventiveMedicationNameHeadic;
  const preventiveMedicationEffectivenessHeadic =
    data?.preventiveMedicationEffectivenessHeadic;
  const updateMedicationTwo = data?.updateMedicationTwo;
  const doseTwo = data?.doseTwo;
  const additionalPainMedicationFrequencyTwo =
    data?.additionalPainMedicationFrequencyTwo;
  const previousMedicationStopYearTwo = data?.previousMedicationStopYearTwo;
  const previousMedicationSideEffectSkal =
    data?.previousMedicationSideEffectSkal;
  const previousMedicationSideEffectBiverkan =
    data?.previousMedicationSideEffectBiverkan;
  const previousMedicationSideEffectBiverkanSecond =
    data?.previousMedicationSideEffectBiverkanSecond;
  const previousMedicationSideEffectSkalSecond =
    data?.previousMedicationSideEffectSkalSecond;
  const previousMedicationStopYearSecond =
    data?.previousMedicationStopYearSecond;
  const hasOtherPreviousPainMedicationStopMedication =
    data?.hasOtherPreviousPainMedicationStopMedication;
  const additionalRadiologyInfo = data?.additionalRadiologyInfo;

  const otherConditionDetails = data?.otherConditionDetails;
  const otherPreventiveMedicationExept = data?.otherPreventiveMedicationExept;
  const otherPreventiveMedicationOtherOne =
    data?.otherPreventiveMedicationOtherOne;
  const otherPreventiveMedicationOtherTwo =
    data?.otherPreventiveMedicationOtherTwo;
  const otherPreventiveMedicationOtherThree =
    data?.otherPreventiveMedicationOtherThree;

  const dizzinessTypeValue = data?.dizzinessType;

  let dizzinessType = '';

  if (
    dizzinessTypeValue?.includes(
      'Yrsel beskrivs som snurrande som när man åker karusell.'
    )
  ) {
    dizzinessType = 'snurrande som när man åker karusell';
  }
  if (
    dizzinessTypeValue?.includes('Yrsel beskrivs som gungande som på en båt.')
  ) {
    dizzinessType = 'gungande som på en båt';
  }
  if (dizzinessTypeValue?.includes('Yrsel beskrivs som allmän olustkänsla.')) {
    dizzinessType = 'allmän olustkänsla';
  }
  if (dizzinessTypeValue?.includes('Yrsel beskrivs som svimningskänsla.')) {
    dizzinessType = 'inget av ovanstående';
  }

  const withdrawalEffectValue = data?.withdrawalEffect;

  let withdrawalEffect = '';

  if (
    withdrawalEffectValue?.includes('med en aning minskad huvudvärk som följd.')
  ) {
    withdrawalEffect = 'En aning minskad huvudvärk';
  } else if (
    withdrawalEffectValue?.includes('med måttligt minskad huvudvärk som följd.')
  ) {
    withdrawalEffect = 'Måttligt minskad huvudvärk';
  } else if (
    withdrawalEffectValue?.includes('med minskad huvudvärk som följd.')
  ) {
    withdrawalEffect = 'Klart minskad huvudvärk';
  } else if (withdrawalEffectValue?.includes('utan förbättring.')) {
    withdrawalEffect = 'Ingen skillnad';
  }

  const radiologyResultValue = data?.radiologyResult || '';
  let radiologyResult = '';

  if (radiologyResultValue?.includes('Undersökning med normalt resultat.')) {
    radiologyResult = 'normalt resultat';
  }
  if (
    radiologyResultValue?.includes(
      'Undersökning med väsentligen normalt med lättare/obetydlig anmärkning.'
    )
  ) {
    radiologyResult = 'väsentligen normalt med lättare/obetydlig anmärkning';
  }
  if (
    radiologyResultValue?.includes('Undersökning med onormalt fynd i form av')
  ) {
    radiologyResult = 'onormalt fynd';
  }

  const mrtResultValue = data?.mrtResult || '';
  let mrtResult = '';

  if (mrtResultValue?.includes('Undersökning med normalt resultat.')) {
    mrtResult = 'normalt resultat';
  }
  if (
    mrtResultValue?.includes(
      'Undersökning med väsentligen normalt med lättare/obetydlig anmärkning.'
    )
  ) {
    mrtResult = 'väsentligen normalt med lättare/obetydlig anmärkning';
  }
  if (mrtResultValue?.includes('Undersökning med onormalt fynd i form av')) {
    mrtResult = 'onormalt fynd';
  }

  let contraceptiveUse;
  const contraceptiveUseValue = data?.contraceptiveUse;
  if (contraceptiveUseValue?.includes('Preventivmedel.')) {
    contraceptiveUse = 'yes';
  } else {
    contraceptiveUse = 'no';
  }

  let pregnancyPlan;
  const pregnancyPlanValue = data?.pregnancyPlan;
  if (pregnancyPlanValue === 'OBS! Planerar graviditet inom 6 månader.') {
    pregnancyPlan = 'yes';
  } else if (pregnancyPlanValue === 'Planerar ej graviditet') {
    pregnancyPlan = 'no';
  } else {
    pregnancyPlan = '';
  }

  let pregnant;
  const pregnantValue = data?.pregnant;
  if (pregnantValue === 'OBS! Är gravid.') {
    pregnant = 'yes';
  } else if (pregnantValue?.includes('Ej gravid')) {
    pregnant = 'no';
  } else {
    pregnant = '';
  }

  const overuseDurationValue = data?.overuseDuration || '';
  let overuseDuration = '';

  if (
    overuseDurationValue?.includes('Överkonsumtion sedan mindre än 1 månad.')
  ) {
    overuseDuration = 'mindre än 1 månad';
  }
  if (overuseDurationValue?.includes('Överkonsumtion sedan 1-3 månader.')) {
    overuseDuration = '1-3 månader';
  }
  if (overuseDurationValue?.includes('Överkonsumtion sedan 3-6 månader.')) {
    overuseDuration = '3-6 månader';
  }
  if (overuseDurationValue?.includes('Överkonsumtion sedan 6-12 månader.')) {
    overuseDuration = '6-12 månader';
  }
  if (overuseDurationValue?.includes('Överkonsumtion sedan 1-2 år.')) {
    overuseDuration = '1-2 år';
  }
  if (overuseDurationValue?.includes('Överkonsumtion sedan 2-5 år.')) {
    overuseDuration = '2-5 år';
  }
  if (overuseDurationValue?.includes('Överkonsumtion sedan 5-10 år.')) {
    overuseDuration = '5-10 år';
  }
  if (overuseDurationValue?.includes('Överkonsumtion sedan 10-20 år.')) {
    overuseDuration = '10-20 år';
  }
  if (overuseDurationValue?.includes('Överkonsumtion sedan mer än 20 år.')) {
    overuseDuration = 'mer än 20 år';
  }
  if (overuseDurationValue?.includes('Överkonsumtion sedan debuten.')) {
    overuseDuration = 'sedan debuten';
  }

  const painMedicationFrequencyValue = data?.painMedicationFrequency || '';
  let painMedicationFrequency = '';

  if (
    painMedicationFrequencyValue?.includes(
      'Tar denna medicin mindre än 1 dag i veckan.'
    )
  ) {
    painMedicationFrequency = 'mindre än 1 dag i veckan';
  }
  if (
    painMedicationFrequencyValue?.includes(
      'Tar denna medicin 1-2 dagar i veckan.'
    )
  ) {
    painMedicationFrequency = '1-2 dagar i veckan';
  }
  if (
    painMedicationFrequencyValue?.includes(
      'Tar denna medicin 3-5 dagar i veckan.'
    )
  ) {
    painMedicationFrequency = '3-5 dagar i veckan';
  }
  if (
    painMedicationFrequencyValue?.includes(
      'Tar denna medicin mer än 5 dagar i veckan.'
    )
  ) {
    painMedicationFrequency = 'mer än 5 dagar i veckan';
  }

  const painMedicationEffectivenessValue =
    data?.painMedicationEffectiveness || '';
  let painMedicationEffectiveness = '';

  if (painMedicationEffectivenessValue?.includes('Den hjälper alltid.')) {
    painMedicationEffectiveness = 'Alltid';
  }
  if (
    painMedicationEffectivenessValue?.includes('Den hjälper för det mesta.')
  ) {
    painMedicationEffectiveness = 'För det mesta';
  }
  if (painMedicationEffectivenessValue?.includes('Den hjälper ibland.')) {
    painMedicationEffectiveness = 'Ibland';
  }
  if (painMedicationEffectivenessValue?.includes('Den hjälper sällan.')) {
    painMedicationEffectiveness = 'Sällan';
  }
  if (painMedicationEffectivenessValue?.includes('Den hjälper aldrig.')) {
    painMedicationEffectiveness = 'Aldrig';
  }

  const painMedicationEffectValue = data?.painMedicationEffect || '';
  let painMedicationEffect = '';

  if (painMedicationEffectValue?.includes('med mycket god effekt.')) {
    painMedicationEffect = 'Mycket god';
  }
  if (painMedicationEffectValue?.includes('med god effekt.')) {
    painMedicationEffect = 'God';
  }
  if (painMedicationEffectValue?.includes('med måttlig effekt.')) {
    painMedicationEffect = 'Måttlig';
  }
  if (painMedicationEffectValue?.includes('med sparsam effekt')) {
    painMedicationEffect = 'Sparsam';
  }
  if (painMedicationEffectValue?.includes('Utan effekt.')) {
    painMedicationEffect = 'Ingen';
  }

  const contraceptiveTypeValue = data?.contraceptiveType || '';
  let contraceptiveType = '';

  if (contraceptiveTypeValue?.includes('p-piller (för in i akt med-lista).')) {
    contraceptiveType = 'p-piller';
  }
  if (contraceptiveTypeValue?.includes('hormonspiral')) {
    contraceptiveType = 'hormonspiral';
  }
  if (contraceptiveTypeValue?.includes('kopparspiral')) {
    contraceptiveType = 'kopparspiral';
  }
  if (contraceptiveTypeValue?.includes('p-stav')) {
    contraceptiveType = 'p-stav';
  }
  if (contraceptiveTypeValue?.includes('p-spruta')) {
    contraceptiveType = 'p-spruta';
  }
  if (contraceptiveTypeValue?.includes('kondom.')) {
    contraceptiveType = 'kondom';
  }
  if (contraceptiveTypeValue?.includes('annat')) {
    contraceptiveType = 'annat';
  }

  const setHeredityMigraineValue = data?.heredityMigraine;
  const heredityMigraine: string[] = [];

  if (setHeredityMigraineValue?.includes('far')) {
    heredityMigraine.push('far');
  }
  if (setHeredityMigraineValue?.includes('mor')) {
    heredityMigraine.push('mor');
  }
  if (setHeredityMigraineValue?.includes('syskon')) {
    heredityMigraine.push('syskon');
  }
  if (setHeredityMigraineValue?.includes('far- eller morförälder')) {
    heredityMigraine.push('far- eller morförälder');
  }
  if (setHeredityMigraineValue?.includes('faster/moster/farbror/morbror')) {
    heredityMigraine.push('faster/moster/farbror/morbror');
  }
  if (setHeredityMigraineValue?.includes('kusin')) {
    heredityMigraine.push('kusin');
  }
  if (setHeredityMigraineValue?.includes('finns ej i släkten')) {
    heredityMigraine.push('nej');
  }

  const setComorbiditiesValue = data?.comorbidities;
  const comorbidities: string[] = [];

  if (setComorbiditiesValue?.includes('nedstämdhet')) {
    comorbidities.push('nedstämdhet');
  }
  if (setComorbiditiesValue?.includes('ångest')) {
    comorbidities.push('ångest');
  }
  if (setComorbiditiesValue?.includes('sömnrubbning')) {
    comorbidities.push('sömnrubbning');
  }
  if (setComorbiditiesValue?.includes('bruxism')) {
    comorbidities.push('bruxism (tandgnissling)');
  }
  if (setComorbiditiesValue?.includes('rikliga snarkningar nattetid')) {
    comorbidities.push('rikliga snarkningar nattetid');
  }
  if (setComorbiditiesValue?.includes('inga övriga tillstånd')) {
    comorbidities.push('nej, inget av ovanstående');
  }

  const setTriggersValue = data?.triggers;
  const currentsetTriggers: string[] = [];

  if (setTriggersValue?.includes('menstruation')) {
    currentsetTriggers.push('menstruation och/eller ägglossning');
  }
  if (setTriggersValue?.includes('födoämne.')) {
    currentsetTriggers.push(
      'födoämne (t ex choklad, starka ostar, citrusfrukter)'
    );
  }
  if (setTriggersValue?.includes('alkohol')) {
    currentsetTriggers.push('alkohol');
  }
  if (setTriggersValue?.includes('stress')) {
    currentsetTriggers.push('stress');
  }
  if (setTriggersValue?.includes('solljus')) {
    currentsetTriggers.push('solljus');
  }
  if (setTriggersValue?.includes('starka lukter')) {
    currentsetTriggers.push('starka lukter');
  }
  if (setTriggersValue?.includes('träning')) {
    currentsetTriggers.push('träning');
  }
  if (setTriggersValue?.includes(' saknas.')) {
    currentsetTriggers.push('inget av ovanstående');
  }

  const setNonMedicationTreatmentsValue = data?.nonMedicationTreatments;
  const nonMedicationTreatments: string[] = [];

  if (setNonMedicationTreatmentsValue?.includes('massage')) {
    nonMedicationTreatments.push('massage');
  }
  if (
    setNonMedicationTreatmentsValue?.includes('naprapat/kiropraktor behandling')
  ) {
    nonMedicationTreatments.push('naprapat/kiropraktor behandling');
  }
  if (setNonMedicationTreatmentsValue?.includes('akupunktur')) {
    nonMedicationTreatments.push('akupunktur');
  }
  if (setNonMedicationTreatmentsValue?.includes('TENS')) {
    nonMedicationTreatments.push('TENS');
  }
  if (
    setNonMedicationTreatmentsValue?.includes(
      'yoga eller annan avslappningsmetod'
    )
  ) {
    nonMedicationTreatments.push('yoga eller annan avslappningsmetod');
  }
  if (setNonMedicationTreatmentsValue?.includes('bettskena')) {
    nonMedicationTreatments.push('bettskena');
  }
  if (
    setNonMedicationTreatmentsValue?.includes('ej provat icke medikamentella ')
  ) {
    nonMedicationTreatments.push('inga av ovanstående');
  }

  if (currentsetTriggers.length > 0) {
    setTriggers(currentsetTriggers);
  }

  const setAuraSymptomsValue = data?.auraSymptoms;
  const currentAuraSymptoms: string[] = [];

  if (setAuraSymptomsValue?.includes('synstörning')) {
    currentAuraSymptoms.push(
      'synstörning (flimmer/blixtar i delar av synfältet)'
    );
  }
  if (setAuraSymptomsValue?.includes('känselstörning')) {
    currentAuraSymptoms.push(
      'känselstörning (domning/stickning i ena sidans arm och/eller ben)'
    );
  }
  if (setAuraSymptomsValue?.includes('svårighet att hitta ord')) {
    currentAuraSymptoms.push('svårighet att hitta ord');
  }
  if (setAuraSymptomsValue?.includes('sluddrigt tal')) {
    currentAuraSymptoms.push('sluddrigt tal');
  }
  if (
    setAuraSymptomsValue?.includes('Har svaghet i ena sidans arm och/eller ben')
  ) {
    currentAuraSymptoms.push('svaghet i ena sidans arm och/eller ben');
  }
  if (setAuraSymptomsValue?.includes('yrsel')) {
    currentAuraSymptoms.push('yrsel');
  }
  if (setAuraSymptomsValue?.includes('svullet')) {
    currentAuraSymptoms.push('svullet ögonlock på samma sida som huvudvärken');
  }
  if (setAuraSymptomsValue?.includes('ögonrodnad')) {
    currentAuraSymptoms.push(
      'ögonrodnad och/eller ökat tårflöde på samma sida som huvudvärken'
    );
  }
  if (setAuraSymptomsValue?.includes('rinnande näsa eller nästäppa')) {
    currentAuraSymptoms.push(
      'rinnande näsa eller nästäppa på samma sida som huvudvärken'
    );
  }
  if (setAuraSymptomsValue?.includes('svettning')) {
    currentAuraSymptoms.push(
      'svettning i pannan och ansiktet på samma sida som huvudvärken'
    );
  }
  if (setAuraSymptomsValue?.includes('Förnekar aura.')) {
    currentAuraSymptoms.push('Inget av ovanstående');
  }
  if (setAuraSymptomsValue?.includes('hängande')) {
    currentAuraSymptoms.push(
      'hängande ögonlock och/eller mindre pupill på samma sida som huvudvärken'
    );
  }

  if (currentAuraSymptoms.length > 0) {
    setAuraSymptoms(currentAuraSymptoms);
  }

  const associatedSymptomsValue = data?.associatedSymptoms;
  const associatedSymptoms: string[] = [];

  if (associatedSymptomsValue?.includes('illamående/kräkningar')) {
    associatedSymptoms.push('illamående/kräkningar');
  }
  if (associatedSymptomsValue?.includes('överkänslighet för ljus')) {
    associatedSymptoms.push('överkänslighet för ljus');
  }
  if (associatedSymptomsValue?.includes('överkänslighet för ljud')) {
    associatedSymptoms.push('överkänslighet för ljud');
  }
  if (associatedSymptomsValue?.includes('överkänslighet för lukter')) {
    associatedSymptoms.push('överkänslighet för lukter');
  }
  if (associatedSymptomsValue?.includes('Förnekar')) {
    associatedSymptoms.push('Nej, inget av ovanstående');
  }

  const diagnosedConditions = data?.diagnosedConditions;

  const currentDiagnosedConditions: string[] = [];

  if (diagnosedConditions?.includes('migrän')) {
    currentDiagnosedConditions.push('Migrän');
  }
  if (diagnosedConditions?.includes('spänningshuvudvärk')) {
    currentDiagnosedConditions.push('Spänningshuvudvärk');
  }
  if (diagnosedConditions?.includes('horton')) {
    currentDiagnosedConditions.push('Horton');
  }
  if (diagnosedConditions?.includes('annan')) {
    currentDiagnosedConditions.push('Annan huvudvärk');
  }
  if (diagnosedConditions?.includes('ej vara')) {
    currentDiagnosedConditions.push('Nej');
  }

  if (currentDiagnosedConditions.length > 0) {
    setDiagnosedConditions(currentDiagnosedConditions);
  }

  let headacheLogged;
  const headacheLoggedValue = data?.headacheLogged;
  if (
    headacheLoggedValue === 'Patienten har registrerat all huvudvärk i dagboken'
  ) {
    headacheLogged = 'yes';
  } else if (headacheLoggedValue?.includes('har inte registrerat')) {
    headacheLogged = 'no';
  } else {
    headacheLogged = '';
  }

  let additionalInfo;
  const additionalInfoValue = data?.additionalInfo;
  if (additionalInfoValue?.includes('Patienten tillägger att')) {
    additionalInfo = 'yes';
  } else if (
    additionalInfoValue === 'Patienten önskar inte tillägga något övrigt.'
  ) {
    additionalInfo = 'no';
  } else {
    additionalInfo = '';
  }

  let attackPatternDuring;
  const attackPatternDuringValue = data?.attackPatternDuring;
  if (
    attackPatternDuringValue ===
    'under perioder av veckor-månader, sedan besvärsfrihet under månader-år innan ny period börjar.'
  ) {
    attackPatternDuring = 'yes';
  } else if (
    attackPatternDuringValue?.includes(
      'kontinuerligt sedan minst ett år tillbaka, möjligen med uppehåll under mindre än tre månader.'
    )
  ) {
    attackPatternDuring = 'no';
  } else {
    attackPatternDuring = '';
  }

  let biologicalSex;
  const biologicalSexValue = data?.biologicalSex;
  if (biologicalSexValue === 'Kvinna') {
    biologicalSex = 'female';
  } else if (biologicalSexValue?.includes('Man')) {
    biologicalSex = 'male';
  } else {
    biologicalSex = '';
  }

  let bloodPressureLastYear;
  const bloodPressureLastYearValue = data?.bloodPressureLastYear;
  if (bloodPressureLastYearValue === 'yes') {
    bloodPressureLastYear = 'yes';
  } else if (bloodPressureLastYearValue?.includes('no')) {
    bloodPressureLastYear = 'no';
  } else {
    bloodPressureLastYear = '';
  }

  let hypertension;
  const hypertensionValue = data?.hypertension;
  if (hypertensionValue === 'Uppger känd hypertoni.') {
    hypertension = 'yes';
  } else if (hypertensionValue?.includes('Nekar känd hypertoni.')) {
    hypertension = 'no';
  } else {
    hypertension = '';
  }

  let otherConditions;
  const otherConditionsValue = data?.otherConditions;
  if (otherConditionsValue === 'Har en känd') {
    otherConditions = 'yes';
  } else if (
    otherConditionsValue?.toLowerCase()?.includes('nekar andra sjukdomar')
  ) {
    otherConditions = 'no';
  } else {
    otherConditions = '';
  }

  let takesPainMedication;
  const takesPainMedicationValue = data?.takesPainMedication;
  if (takesPainMedicationValue === 'Vid anfall tas (1)') {
    takesPainMedication = 'yes';
  } else if (
    takesPainMedicationValue?.includes('Vid anfall tas ingen anfallsmedicin.')
  ) {
    takesPainMedication = 'no';
  } else {
    takesPainMedication = '';
  }

  let controllMrt;
  const controllMrtValue = data?.controllMrt;
  if (
    controllMrtValue ===
    'Har genomgått magnetkameraundersökning (MRT) av huvudet'
  ) {
    controllMrt = 'yes';
  } else if (controllMrtValue?.includes('Har ej genomgått')) {
    controllMrt = 'no';
  } else {
    controllMrt = '';
  }

  let radiologyExam;
  const radiologyExamValue = data?.radiologyExam;
  if (
    radiologyExamValue ===
    'Har genomgått skiktröntgen (datortomografi, CT, DT) av huvudet'
  ) {
    radiologyExam = 'yes';
  } else if (radiologyExamValue?.includes('Har ej genomgått')) {
    radiologyExam = 'no';
  } else {
    radiologyExam = '';
  }

  let hasWithdrawal;
  const hasWithdrawalValue = data?.hasWithdrawal;
  if (hasWithdrawalValue === 'Har genomgått läkemedelsavgiftning') {
    hasWithdrawal = 'yes';
  } else if (
    hasWithdrawalValue?.includes('Läkemedelsavgiftning har ej genomförts.')
  ) {
    hasWithdrawal = 'no';
  } else {
    hasWithdrawal = '';
  }

  let medicationOveruse;
  const medicationOveruseValue = data?.medicationOveruse;
  if (
    medicationOveruseValue ===
    'Bejakar överkonsumtion av analgetika. Överkonsumerar'
  ) {
    medicationOveruse = 'yes';
  } else if (medicationOveruseValue?.includes('Nekar')) {
    medicationOveruse = 'no';
  } else {
    medicationOveruse = '';
  }

  let worseningOverTime;
  const worseningOverTimeValue = data?.worseningOverTime;

  if (
    worseningOverTimeValue?.includes(
      'Anfallsfrekvensen har försämrats med tiden.'
    )
  ) {
    worseningOverTime = 'yes';
  } else if (
    worseningOverTimeValue?.includes(
      'Anfallsfrekvensen har varit oförändrad sedan debuten.'
    )
  ) {
    worseningOverTime = 'no';
  } else {
    worseningOverTime = '';
  }

  let physicalActivityEffect;
  const physicalActivityEffectValue = data?.physicalActivityEffect;
  if (
    physicalActivityEffectValue?.includes(
      'Pågående huvudvärk förvärras av normal fysisk aktivitet.'
    )
  ) {
    physicalActivityEffect = 'yes';
  } else if (
    physicalActivityEffectValue?.includes(
      'Pågående huvudvärk förvärras inte av normal fysisk aktivitet.'
    )
  ) {
    physicalActivityEffect = 'no';
  } else {
    physicalActivityEffect = '';
  }

  let hasMultipleHeadaches;
  const hasMultipleHeadachesValue = data?.hasMultipleHeadaches;
  if (hasMultipleHeadachesValue === 'Patient med flera typer av huvudvärk.') {
    hasMultipleHeadaches = 'yes';
  } else if (
    hasMultipleHeadachesValue?.includes('Patient med en typ av huvudvärk.')
  ) {
    hasMultipleHeadaches = 'no';
  } else {
    hasMultipleHeadaches = '';
  }

  let attackPattern;
  const attackPatternValue = data?.attackPattern;
  if (
    attackPatternValue === 'Attacker minst varannan dag upp till 8 ggr dagligen'
  ) {
    attackPattern = 'yes';
  } else if (attackPatternValue?.includes('Inget clustermönster')) {
    attackPattern = 'no';
  } else {
    attackPattern = '';
  }

  if (ageFirstAttack === 'Huvudvärken debuterade vid 0-10 års ålder.') {
    ageFirstAttack = '0-10 år';
  } else if (ageFirstAttack === 'Huvudvärken debuterade vid 11-20 års ålder.') {
    ageFirstAttack = '11-20 år';
  } else if (ageFirstAttack === 'Huvudvärken debuterade vid 21-30 års ålder.') {
    ageFirstAttack = '21-30 år';
  } else if (ageFirstAttack === 'Huvudvärken debuterade vid 31-40 års ålder.') {
    ageFirstAttack = '31-40 år';
  } else if (ageFirstAttack === 'Huvudvärken debuterade vid 41-50 års ålder.') {
    ageFirstAttack = '41-50 år';
  } else if (
    ageFirstAttack === 'Huvudvärken debuterade då patienten var äldre än 50 år.'
  ) {
    ageFirstAttack = 'mer än 50 år';
  }

  if (headacheDuration === 'Ett obehandlat anfall varar mindre än 1 timme.') {
    headacheDuration = 'mindre än 1 timme';
  } else if (
    headacheDuration === 'Ett obehandlat anfall varar ca 1-3 timmar.'
  ) {
    headacheDuration = '1-3 timmar';
  } else if (
    headacheDuration === 'Ett obehandlat anfall varar ca 4-72 timmar.'
  ) {
    headacheDuration = '4-72 timmar';
  } else if (
    headacheDuration === 'Ett obehandlat anfall varar mer än 72 timmar.'
  ) {
    headacheDuration = 'mer än 72 timmar';
  }

  if (painLocation === 'Smärtan är vanligtvis lokaliserad till hela huvudet') {
    painLocation = 'i hela huvudet';
  } else if (
    painLocation === 'Smärtan är vanligtvis lokaliserad till halva huvudet'
  ) {
    painLocation = 'i halva huvudet';
  } else if (
    painLocation ===
    'Smärtan är vanligtvis lokaliserad som ett band runt huvudet'
  ) {
    painLocation = 'som ett band runt huvudet';
  } else if (
    painLocation === 'Smärtan är vanligtvis lokaliserad till nacken/bakhuvudet'
  ) {
    painLocation = 'i nacken/bakhuvudet';
  } else if (
    painLocation ===
    'Smärtan är vanligtvis lokaliserad till en specifik punkt eller litet område av huvudet'
  ) {
    painLocation = 'i en specifik punkt eller litet område av huvudet';
  } else if (
    painLocation ===
    'Smärtan är vanligtvis lokaliserad i eller runt ena ögat eller i tinningen nära ena ögat.'
  ) {
    painLocation = 'i eller runt ena ögat eller i tinningen nära ena ögat';
  }

  if (painCharacter === 'Smärtan är av pulserande/dunkande karaktär.') {
    painCharacter = 'pulserande/dunkande';
  } else if (painCharacter === 'Smärtan är av molande karaktär.') {
    painCharacter = 'molande';
  } else if (painCharacter === 'Smärtan är av skärande karaktär.') {
    painCharacter = 'skärande';
  } else if (painCharacter === 'Smärtan är av brännande/svidande karaktär.') {
    painCharacter = 'brännande/svidande';
  } else if (painCharacter === 'Smärtan är av huggande karaktär.') {
    painCharacter = 'huggande';
  } else if (painCharacter === 'Smärtan är av tryckande karaktär.') {
    painCharacter = 'tryckande';
  }

  if (painIntensity === 'Som värst är den lätt.') {
    painIntensity = 'lätt';
  } else if (painIntensity === 'Som värst är den måttlig.') {
    painIntensity = 'måttlig';
  } else if (painIntensity === 'Som värst är den intensiv.') {
    painIntensity = 'intensiv';
  }

  if (
    preferredActionDuringAttack ===
    'Lägger sig ned i ett mörkt och tyst rum under pågående anfall, om möjlighet finns.'
  ) {
    preferredActionDuringAttack = 'Lägger mig ned i ett mörkt och tyst rum';
  } else if (
    preferredActionDuringAttack ===
    'Tar en promenad under pågående anfall, om möjlighet finns.'
  ) {
    preferredActionDuringAttack = 'Tar en promenad';
  } else if (
    preferredActionDuringAttack ===
    'Sätter sig ned och tar det lugnt under pågående anfall, om möjlighet finns.'
  ) {
    preferredActionDuringAttack = 'Sätter mig ned och tar det lugnt';
  } else if (
    preferredActionDuringAttack ===
    'Går omkring då smärtan är svår att stå ut med eller förvärras i liggande under pågående anfall, om möjlighet finns.'
  ) {
    preferredActionDuringAttack =
      'Går omkring då smärtan är svår att stå ut med eller förvärras i liggande';
  }

  if (
    dizzinessDuration === 'Uppger mindre än 5 min duration av nämnda symtom.'
  ) {
    dizzinessDuration = 'mindre än 5 min';
  } else if (
    dizzinessDuration === 'Uppger 5-15 min duration av nämnda symtom.'
  ) {
    dizzinessDuration = '5-15 min';
  } else if (
    dizzinessDuration === 'Uppger 15-60 min duration av nämnda symtom.'
  ) {
    dizzinessDuration = '15-60 min';
  } else if (
    dizzinessDuration === 'Uppger 1-4 timmar duration av nämnda symtom.'
  ) {
    dizzinessDuration = '1-4 timmar';
  } else if (
    dizzinessDuration === 'Uppger mer än 4 timmars duration av nämnda symtom.'
  ) {
    dizzinessDuration = 'mer än 4 timmar';
  }

  if (headacheFrequency === 'Har denna huvudvärk mindre än en gång per år') {
    headacheFrequency = 'mindre än en gång per år';
  } else if (headacheFrequency === 'Har denna huvudvärk 1-11 gånger per år') {
    headacheFrequency = '1-11 gånger per år';
  } else if (headacheFrequency === 'Har denna huvudvärk 1-3 ggr per månad') {
    headacheFrequency = '1-3 ggr per månad';
  } else if (headacheFrequency === 'Har denna huvudvärk 4-7 ggr per månad') {
    headacheFrequency = '4-7 ggr per månad';
  } else if (headacheFrequency === 'Har denna huvudvärk 8-14 ggr per månad') {
    headacheFrequency = '8-14 ggr per månad';
  } else if (headacheFrequency === 'Har denna huvudvärk 15-29 ggr per månad') {
    headacheFrequency = '15-29 ggr per månad';
  } else if (headacheFrequency === 'Har denna huvudvärk dagligen') {
    headacheFrequency = 'dagligen';
  }

  if (frequencyDuration === ' sedan mindre än en månad tillbaka.') {
    frequencyDuration = 'mindre än 1 månad';
  } else if (frequencyDuration === ' sedan 1-3 månader.') {
    frequencyDuration = '1-3 månader';
  } else if (frequencyDuration === ' sedan 3-6 månader.') {
    frequencyDuration = '3-6 månader';
  } else if (frequencyDuration === ' sedan 6-12 månader.') {
    frequencyDuration = '6-12 månader';
  } else if (frequencyDuration === ' sedan 1-2 år.') {
    frequencyDuration = '1-2 år';
  } else if (frequencyDuration === ' sedan 2-5 år.') {
    frequencyDuration = '2-5 år';
  } else if (frequencyDuration === ' sedan 5-10 år.') {
    frequencyDuration = '5-10 år';
  } else if (frequencyDuration === ' sedan 10-20 år.') {
    frequencyDuration = '10-20 år';
  } else if (frequencyDuration === ' sedan mer än 20 år.') {
    frequencyDuration = 'mer än 20 år';
  } else if (frequencyDuration === ' sedan debuten.') {
    frequencyDuration = 'sedan debuten';
  }

  if (
    initialFrequency ===
    'De första åren efter debuten var huvudvärksfrekvensen mindre än en gång per år.'
  ) {
    initialFrequency = 'mindre än en gång per år';
  } else if (
    initialFrequency ===
    'De första åren efter debuten var huvudvärksfrekvensen 1-11 gånger per år.'
  ) {
    initialFrequency = '1-11 gånger per år';
  } else if (
    initialFrequency ===
    'De första åren efter debuten var huvudvärksfrekvensen 1-3 ggr per månad.'
  ) {
    initialFrequency = '1-3 ggr per månad';
  } else if (
    initialFrequency ===
    'De första åren efter debuten var huvudvärksfrekvensen 4-7 ggr per månad.'
  ) {
    initialFrequency = '4-7 ggr per månad';
  } else if (
    initialFrequency ===
    'De första åren efter debuten var huvudvärksfrekvensen 8-14 ggr per månad.'
  ) {
    initialFrequency = '8-14 ggr per månad';
  } else if (
    initialFrequency ===
    'De första åren efter debuten var huvudvärksfrekvensen 15-29 ggr per månad.'
  ) {
    initialFrequency = '15-29 ggr per månad';
  } else if (
    initialFrequency ===
    'De första åren efter debuten var huvudvärksfrekvensen dagligen.'
  ) {
    initialFrequency = 'dagligen';
  }

  if (
    headacheFreeDays ===
    'Uppskattar att det förekommer 30 helt huvudvärksfria dagar per månad.'
  ) {
    headacheFreeDays = '30';
  } else if (
    headacheFreeDays ===
    'Uppskattar att det förekommer 15-30 helt huvudvärksfria dagar per månad.'
  ) {
    headacheFreeDays = '15-30';
  } else if (
    headacheFreeDays ===
    'Uppskattar att det förekommer 8-14 helt huvudvärksfria dagar per månad.'
  ) {
    headacheFreeDays = '8-14';
  } else if (
    headacheFreeDays ===
    'Uppskattar att det förekommer 3-7 helt huvudvärksfria dagar per månad.'
  ) {
    headacheFreeDays = '3-7';
  } else if (
    headacheFreeDays ===
    'Uppskattar att det förekommer 1-2 helt huvudvärksfria dagar per månad.'
  ) {
    headacheFreeDays = '1-2';
  } else if (
    headacheFreeDays ===
    'Uppskattar att det inte förekommer någon helt huvudvärksfri dag per månad.'
  ) {
    headacheFreeDays = 'inga';
  }

  if (
    worseningDuration === 'Anfallsfrekvensen har ökat sedan mindre än 1 månad.'
  ) {
    worseningDuration = 'mindre än 1 månad';
  } else if (
    worseningDuration === 'Anfallsfrekvensen har ökat sedan 1-3 månader.'
  ) {
    worseningDuration = '1-3 månader';
  } else if (
    worseningDuration === 'Anfallsfrekvensen har ökat sedan 3-6 månader.'
  ) {
    worseningDuration = '3-6 månader';
  } else if (
    worseningDuration === 'Anfallsfrekvensen har ökat sedan 6-12 månader.'
  ) {
    worseningDuration = '6-12 månader';
  } else if (worseningDuration === 'Anfallsfrekvensen har ökat sedan 1-2 år.') {
    worseningDuration = '1-2 år';
  } else if (worseningDuration === 'Anfallsfrekvensen har ökat sedan 2-5 år.') {
    worseningDuration = '2-5 år';
  } else if (
    worseningDuration === 'Anfallsfrekvensen har ökat sedan 5-10 år.'
  ) {
    worseningDuration = '5-10 år';
  } else if (
    worseningDuration === 'Anfallsfrekvensen har ökat sedan 10-20 år.'
  ) {
    worseningDuration = '10-20 år';
  } else if (
    worseningDuration === 'Anfallsfrekvensen har ökat sedan mer än 20 år.'
  ) {
    worseningDuration = 'mer än 20 år';
  }

  if (
    neurologicalFamilyDiseases?.includes('Annan neurologisk sjukdom i släkten:')
  ) {
    neurologicalFamilyDiseases = 'yes';
  } else if (
    neurologicalFamilyDiseases?.includes(
      'Annan neurologisk sjukdom i släkten finns ej'
    )
  ) {
    neurologicalFamilyDiseases = 'no';
  }

  return {
    hasMultipleHeadaches,
    headacheLogged,
    ageFirstAttack,
    headacheDuration,
    painLocation,
    attackPattern,
    painCharacter,
    painIntensity,
    physicalActivityEffect,
    preferredActionDuringAttack,
    medicationOveruse,
    hasWithdrawal,
    radiologyExam,
    controllMrt,
    takesPainMedication,
    dizzinessDuration,
    headacheFrequency,
    frequencyDuration,
    initialFrequency,
    worseningOverTime,
    headacheFreeDays,
    worseningDuration,
    neurologicalFamilyDiseases,
    otherConditions,
    hypertension,
    bloodPressureLastYear,
    biologicalSex,
    additionalInfo,
    additionalInfoText,
    missingDiaryInfo,
    hasPreviousPainMedication,
    diagnosedConditionsDateMigran,
    diagnosisConditionsData,
    diagnosisConditionsDataSpanningshuvudvark,
    diagnosedConditionsDateSpanningshuvudvark,
    diagnosisConditionsDataHorton,
    diagnosedConditionsDateHorton,
    attackPatternDuring,
    comorbidities,
    nonMedicationTreatments,
    bettskenEffect,
    massageEffect,
    acupunctureEffect,
    tensEffect,
    yogaEffect,
    naprapatEffect,
    preventiveMedication,
    hasPreviousPreventiveMedication,
    otherPreventiveMedication,
    otherPreventiveMedicationOtherNo,
    heredityMigraine,
    weight,
    height,
    mrtDate,
    mrtLocation,
    mrtResult,
    pregnant,
    pregnancyPlan,
    contraceptiveUse,
    contraceptiveType,
    painMedicationName,
    painMedicationDose,
    painMedicationEffect,
    painMedicationEffectiveness,
    painMedicationFrequency,
    hasAdditionalAttackMedication,
    neurologicalFamilyDiagnosis,
    neurologicalFamilyRelation,
    overusedMedication,
    overuseDuration,
    hasOtherPreviousPainMedicationStopSecond,
    hasOtherPreviousPainMedicationStop,
    previousMedicationName,
    previousMedicationNameSecond,
    previousMedicationDose,
    previousMedicationDoseSecond,
    previousMedicationEffectiveness,
    previousMedicationEffectivenessSecond,
    previousMedicationFrequency,
    previousMedicationFrequencySecond,
    previousMedicationStartYear,
    previousMedicationStartYearSecond,
    previousMedicationStopReason,
    previousMedicationStopReasonSecond,
    previousMedicationStopYear,
    radiologyDate,
    radiologyLocation,
    radiologyResult,
    describeAnomaly,
    withdrawalDate,
    withdrawalEffect,
    otherPreventiveMedicationOtherNoWitch,
    otherPreventiveMedicationOtherNoWhatReaktion,
    otherAlergy,
    otherHeadacheType,
    diagnosedConditionsDateOther,
    previousMedicationOtherReasonTwo,
    previousMedicationOtherReason,
    preventiveMedicationHeadic,
    preventiveMedicationNameHeadic,
    preventiveMedicationDoseHeadic,
    preventiveMedicationEffectivenessHeadic,
    preventiveMedicationStartYearHeadic,
    preventiveMedicationSideEffectsHeadic,
    preventiveMedicationSideEffectDetailsHeadic,
    hasAdditionalPreventiveMedicationHeadic,
    updateMedicationTwo,
    doseTwo,
    additionalPainMedicationFrequencyTwo,
    previousMedicationStopYearTwo,
    previousMedicationSideEffect,
    previousMedicationSideEffectSkal,
    previousMedicationSideEffectBiverkan,
    previousMedicationSideEffectBiverkanSecond,
    previousMedicationSideEffectSkalSecond,
    previousMedicationStopYearSecond,
    hasOtherPreviousPainMedicationStopMedication,
    associatedSymptoms,
    additionalRadiologyInfo,
    bloodPressureValue,
    otherConditionDetails,
    otherPreventiveMedicationExept,
    otherPreventiveMedicationOther,
    otherPreventiveMedicationOtherOne,
    otherPreventiveMedicationOtherTwo,
    otherPreventiveMedicationOtherThree,
    otherPreventiveMedicationNameOne,
    otherPreventiveMedicationNameTwo,
    otherPreventiveMedicationNameThree,
    otherPreventiveMedicationNameThreeText,
    otherPreventiveMedicationName,
    dizzinessType,
    diagnosedConditions,
  };
}
